import { render, staticRenderFns } from "./Support.vue?vue&type=template&id=17c9827b&"
import script from "./Support.vue?vue&type=script&lang=js&"
export * from "./Support.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17c9827b')) {
      api.createRecord('17c9827b', component.options)
    } else {
      api.reload('17c9827b', component.options)
    }
    module.hot.accept("./Support.vue?vue&type=template&id=17c9827b&", function () {
      api.rerender('17c9827b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/support/Support.vue"
export default component.exports